class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="country_code"], input[name="language_code"]'),
      panel: this.querySelector('ul'),
    };

    this.elements.panel
      .querySelectorAll('a')
      .forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}
customElements.define('localization-form', LocalizationForm);
